import { useTheme } from "@repo/tokens";
import { getFlashcardProgressFillStyle } from "../flashcardsDynamicStyles";
import styles from "./FlashcardProgressRow.module.scss";

type FlashcardProgressRowProps = {
  currentIndex: number;
  totalWithQuestions: number;
};

export function FlashcardProgressRow({
  currentIndex,
  totalWithQuestions,
}: FlashcardProgressRowProps) {
  const { theme } = useTheme();
  const fillStyle = getFlashcardProgressFillStyle(
    currentIndex + 1,
    totalWithQuestions,
  );

  return (
    <div className={styles.row}>
      <div
        className={styles.track}
        style={{ backgroundColor: theme.colors.primary[80] }}
      >
        <div
          className={styles.fill}
          style={{
            ...fillStyle,
            backgroundColor: theme.colors.success[60],
          }}
        />
      </div>
      <p className={styles.count} style={{ color: theme.colors.neutral[10] }}>
        {currentIndex + 1}/{totalWithQuestions}
      </p>
    </div>
  );
}
